var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E8F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12262_73046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.68 8C11.48 8 9.92 9.3875 9.92 13.12V34.24C9.92 35.11 10.175 35.7375 10.56 36.2V38.08C10.56 39.1375 11.4225 40 12.48 40H15.04C16.0975 40 16.96 39.1375 16.96 38.08V37.44H31.04V38.08C31.04 39.1375 31.9025 40 32.96 40H35.52C36.5775 40 37.44 39.1375 37.44 38.08V36.2C37.825 35.7375 38.08 35.11 38.08 34.24V13.76C38.08 10.9725 37.735 8 33.6 8H15.68ZM17.6 10.56H31.04C31.395 10.56 31.68 10.8475 31.68 11.2V12.48C31.68 12.8325 31.395 13.12 31.04 13.12H17.6C17.2475 13.12 16.96 12.8325 16.96 12.48V11.2C16.96 10.8475 17.2475 10.56 17.6 10.56ZM15.04 15.04H32.96C34.24 15.04 34.88 15.68 34.88 16.96V24.64C34.88 25.92 33.63 26.52 32.96 26.52L15.04 26.56C13.76 26.56 13.12 25.92 13.12 24.64V16.96C13.12 15.68 13.76 15.04 15.04 15.04ZM9.28 15.68C8.575 15.68 8 16.255 8 16.96V22.08C8 22.785 8.575 23.36 9.28 23.36V15.68ZM38.72 15.68V23.36C39.4275 23.36 40 22.785 40 22.08V16.96C40 16.255 39.4275 15.68 38.72 15.68ZM15.36 29.76C16.5975 29.76 17.6 30.7625 17.6 32C17.6 33.2375 16.5975 34.24 15.36 34.24C14.1225 34.24 13.12 33.2375 13.12 32C13.12 30.7625 14.1225 29.76 15.36 29.76ZM32.64 29.76C33.8775 29.76 34.88 30.7625 34.88 32C34.88 33.2375 33.8775 34.24 32.64 34.24C31.4025 34.24 30.4 33.2375 30.4 32C30.4 30.7625 31.4025 29.76 32.64 29.76Z",
    fill: "#3077F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12262_73046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleIcon);
export default __webpack_public_path__ + "static/media/vehicleIcon.da69c3c101121ce90e708cb280488868.svg";
export { ForwardRef as ReactComponent };